import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { getLandingPage } from "../api";
import { landingPagesKeys } from "./keys";
import type { LandingPage } from "../../types";

export const useLandingPageQuery = (id: number | string | undefined) => {
  return useQuery<LandingPage>({
    queryKey: landingPagesKeys.detail(id),
    queryFn: async () => {
      const { data } = await getLandingPage(id!);
      return data;
    },
    enabled: !!id,
    ...reactQueryCacheAndRefetchOptions,
  });
};
